export const SIDE_PADDING = 24
